import React from 'react';

import CurrencyInput from '../shared/inputs/CurrencyInput';
import CustomTd from '../shared/table/CustomTd';
import DeleteButton from '../shared/buttons/DeleteButton';
import FormControl from '../shared/inputs/FormControl';

const DetailEditor = ({
    deleteItem,
    formChange,
    item,
    disabled
}) => {
    return (
        <tr>
            <CustomTd className="border-0">
                <FormControl
                    defaultValue={item.description}
                    name="description"
                    onChange={formChange}
                    placeholder="Description"
                    required={!item.newItem}
                    validationError={item.description_error}
                    disabled={disabled}
                />
            </CustomTd>
            <CustomTd width="100px" className="border-0">
                <CurrencyInput
                    name="amount"
                    onChange={formChange}
                    placeholder="Amount"
                    required={!item.newItem}
                    validationError={item.amount_error}
                    value={item.amount}
                    disabled={disabled}
                />
            </CustomTd>
            <CustomTd width="45px" className="button-cell border-0">
                <div className="button-wrapper d-inline-block">
                    <DeleteButton
                        confirmDelete={false}
                        onClick={deleteItem}
                        showText={false}
                        disabled={disabled || item.newItem}
                    />
                </div>
            </CustomTd>
        </tr>
    );
}

export default DetailEditor;